<script>
import { productDetailResource } from '@api/catalog.service'

export default {
  props: {
    objectId: {
      type: [Number, String],
    },
  },

  data() {
    return {
      info: {},
    }
  },

  async created() {
    await this.getData()
  },

  methods: {
    async getData() {
      const params = { id: this.objectId }

      const { data } = await productDetailResource.execute(params)

      this.info = data
    },
  },

  render() {
    return this.$scopedSlots.default({
      productInfo: this.info,
    })
  },
}
</script>
